import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS, Housing} from '@chekin/core';
import {API} from '@chekin/api';

type OptionsProps = Omit<UseQueryOptions<Housing, Error>, 'queryFn' | 'queryKey'>;

function useFetchHousing(housingId?: string, options?: OptionsProps) {
  return useQuery<Housing, Error>({
    queryKey: [QUERY_CACHE_KEYS.housing, housingId],
    queryFn: () => API.housing.getOne(housingId || ''),
    ...options,
  });
}

export {useFetchHousing};
